const MainTheStarterKitTryNow = function() {
    function MainTheStarterKitTryNow() {
        this.selector = {
            productdetails: document.querySelectorAll('.product-details-btn'),
            productdetailsmodal: document.getElementById('product-details-modal'),
            productdetailsmodaloverlay: document.getElementById('product-details-modal-overlay'),
            modalclose: document.getElementById('product-details-modal-close'),
            steponevariantselected: document.getElementById('step-one-variant-selected'),
            steptwovariantselected: document.getElementById('step-two-variant-selected'),
            addtowizard: document.querySelectorAll('.add-to-wizard'),
            addtowizardone: document.querySelectorAll('.step-one-container .add-to-wizard'),
            addtowizardtwo: document.querySelectorAll('.step-two-container .add-to-wizard'),
            kitclose: document.querySelectorAll('.wizard-container > .variant-selection .kit-close'),
            steponecontainer: document.getElementById("step-one-container"),
            steptwocontainer: document.getElementById("step-two-container"),
            starterkitaddtocart: document.getElementById("starter-kit-add-to-cart"),
            sellingplanoptionsselect: document.getElementById("selling-plan-options-select"),
            stepsbuilderstepone: document.getElementById("steps-builder-step-one"),
            stepsbuildersteptwo: document.getElementById("steps-builder-step-two"),
            sellingplansubscriptionselection: document.getElementsByName("selling_plan_subscription_selection"),
            complimentaryselected: document.getElementById("complimentary-selected"),
            mobilecollapsablearrow: document.getElementById("mobile-collapsable-arrow"),
            secondvariantselecteditems: document.querySelector("#second-variants-selected-items .step-two-variant-selected"),
            highlightcountscontainer: document.getElementById("highlight-counts-container"),
            highlightscentrunningscount: document.getElementById("highlight-scents-running-count"),
            highlightscentsmaxcount: document.getElementById("highlight-scents-max-count"),
            tryNowCta: document.querySelector('#trynow-custom-cta'),
            tryNowCtaContainer: document.querySelector('.trynow-cta-container')
        }
        this.state = {
            step_one: [],
            step_two: [],
            filteredVariantSellingPlan: [],
            variantSizeLimit: 0,
            variantRunningCount: 0 
        }
        this.final = {
            withsubscription_el: document.getElementById("final-with-subscription"),
            onetimepurchase_el: document.getElementById("final-one-time-purchase"),
            first_product_price: 0,
            second_product_price: 0,
            first_product_discount_price: 0,
            second_product_discount_price: 0,
            total_discounted_price_el: document.getElementById("final-discounted-price"),
            total_regular_price_el: document.getElementById("final-cross-out-price"),
            current_currency: '$',
            subscription_plan: null,
            first_variant_id: null,
            second_variants: [],
            first_variant_available: false
        }
        this.load();
        this.onBrowserLoad();
        this.onMetaBrowser();
        
        setTimeout(() => {
          if(!window.trynow) return;
          this.tryNowLoad();
        },1100)  
        
    }
    MainTheStarterKitTryNow.prototype.load = function() {
        var _ = this;
        if(_.selector.productdetails.length > 0) {
            _.selector.productdetails.forEach(btn => {
                btn.addEventListener('click', event => {
                    const templateContent = event.target.closest('.image').querySelector(`#product-details-${event.target.closest('button').dataset.templateId}`).content;
                    _.selector.productdetailsmodal.querySelector(".render").innerHTML = "";
                    _.selector.productdetailsmodal.querySelector(".render").appendChild(document.importNode(templateContent, true));
                    _.selector.productdetailsmodal.classList.add('active');
                    _.selector.productdetailsmodaloverlay.classList.add('active');
                })
            })
        }
        if(_.selector.modalclose) {
            _.selector.modalclose.addEventListener('click', () => {
                _.selector.productdetailsmodal.classList.remove('active');
                _.selector.productdetailsmodaloverlay.classList.remove('active');
            })
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(btn => {
                btn.addEventListener('click', async event => {
                    document.querySelector('.selling-plan-subscription').click();
                    if(event.target.closest('button').dataset.stepsNumber === 'one') {
                        var variantImage = document.createElement('img');
                        variantImage.src = event.target.closest('button').dataset.variantImage;
                        variantImage.alt = event.target.closest('button').dataset.variantTitle;
                        variantImage.width = "125";
                        variantImage.height = "125";
                        _.selector.steponevariantselected.querySelector('.kit-close').classList.add("active");
                        _.selector.steponevariantselected.querySelector('.image').innerHTML = "";
                        _.selector.steponevariantselected.querySelector('.image').appendChild(variantImage);      
                        _.selector.steponevariantselected.querySelector('.selected-details').classList.add('active');
                        _.selector.steponevariantselected.querySelector('.selected-details .title').textContent = event.target.closest("button").dataset.variantTitle.split(' / ')[0];
                        const ExtactVariantSize = event.target.closest("button").dataset.refinedVariantTitle.match(/\d+/g);
                        _.state.variantSizeLimit = 1;
                        _.selector.steponevariantselected.querySelector('.selected-details .pricing .regular').textContent = event.target.closest("button").dataset.compareAtPrice;
                        if(parseInt(event.target.closest("button").dataset.refinedDiscountedPrice) != parseInt(event.target.closest("button").dataset.refinedRegularPrice)) {
                            _.selector.steponevariantselected.querySelector('.selected-details .pricing .compare-at-price').textContent = event.target.closest("button").dataset.regularPrice;                        
                        }
                        if(window.trynow) {
                            let hasPassedTryLink = await window.trynow.hasPassedTryLink();
                            if(hasPassedTryLink) {
                                let trynowBadgeStepOne = document.querySelector('.step-one-trynow-badge');
                                if(trynowBadgeStepOne) trynowBadgeStepOne.innerHTML = `<span class="trynow-badge">$0 NOW</span> <span class="trynow-badge-price">${event.target.closest("button").dataset.regularPrice}</span>`;
                            }   
                        }
                        _.state.step_one.push({variantId: event.target.closest('button').dataset.variantId, regularPrice: event.target.closest('button').dataset.regularPrice, stepNumber: event.target.closest('button').dataset.stepsNumber, variantTitle: event.target.closest('button').dataset.refinedVariantTitle});
                        _.final.first_product_price = parseInt(event.target.closest('button').dataset.refinedRegularPrice);
                        _.final.first_product_discount_price = parseInt(event.target.closest('button').dataset.refinedDiscountedPrice);
                        _.final.current_currency = event.target.closest('button').dataset.currentCurrency;
                        _.final.first_variant_id = event.target.closest('button').dataset.variantId;
                        _.selector.steptwocontainer.scrollIntoView({behavior: 'smooth', block: 'start'});
                        _.recalculate();
                    }
                    if(event.target.closest('button').dataset.stepsNumber === 'two') {            
                        _.state.filteredVariantSellingPlan = [];
                        _.state.filteredVariantSellingPlan = window.second_products_selling_plan.filter(plan => plan.variantId === event.target.closest("button").dataset.variantId);
                        if(_.state.filteredVariantSellingPlan.length > 0) {      
                            if(_.selector.sellingplanoptionsselect) {
                                _.selector.sellingplanoptionsselect.innerHTML = "";
                                let loopIndex = 0;
                                for (const option of _.state.filteredVariantSellingPlan) {
                                    var selling_plan_option = document.createElement("option");
                                    selling_plan_option.value = option.sellingPlanId;
                                    selling_plan_option.text = option.sellingPlanName;
                                    selling_plan_option.dataset.sellingPlanPriceType = option.sellingPlanPriceType;
                                    selling_plan_option.dataset.sellingPlanPriceValue = option.sellingPlanPriceValue;
                                    selling_plan_option.dataset.variantId = option.variantId;
                                    selling_plan_option.dataset.variantPrice = option.variantPrice;
                                    selling_plan_option.dataset.currentCurrency = option.currentCurrency;
                                    selling_plan_option.dataset.sellingPlanId = option.sellingPlanId;
                                    loopIndex == 0 && (selling_plan_option.selected = true);
                                    loopIndex == 0 && (_.final.subscription_plan = option.sellingPlanId);
                                    _.selector.sellingplanoptionsselect.append(selling_plan_option);
                                    loopIndex++;
                                }      
                                _.selector.sellingplanoptionsselect.classList.add('active');                         
                            }                            
                        }                        
                        _.selector.starterkitaddtocart.classList.add("active");
                        _.final.second_product_price = parseInt(event.target.closest('button').dataset.refinedPrice);
                        _.final.second_product_discount_price = parseInt(event.target.closest('button').dataset.refinedDiscountedPrice);
                        _.final.withsubscription_el.textContent = `${_.final.current_currency}${(_.final.second_product_discount_price / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
                        // to remove the decimals if the price doesn't have any
                        if (_.final.withsubscription_el.textContent.slice(-2) == '00') {
                            _.final.withsubscription_el.textContent = `${_.final.current_currency}${(_.final.second_product_discount_price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        }
                        _.final.onetimepurchase_el.textContent = `${_.final.current_currency}${(_.final.second_product_price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        if(!_.final.second_variants.includes(event.target.closest('button').dataset.variantId)) {
                            _.final.second_variants.push(event.target.closest('button').dataset.variantId);
                            _.state.variantRunningCount = _.state.variantRunningCount + 1;
                        }                        
                        const addednewscents = document.createElement("div");
                        addednewscents.classList.add("step-two-variant-selected");
                        addednewscents.classList.add("active");
                        addednewscents.dataset.variantId = event.target.closest('button').dataset.variantId;
                        addednewscents.dataset.variantTitle = event.target.closest('button').dataset.variantTitle;
                        let hasPassedTryLink = false;
                        let isCookieValueMatch = false;
                        if(window.trynow) {
                            hasPassedTryLink = await window.trynow.hasPassedTryLink();
                            isCookieValueMatch = await _.checkCookieValue('_tn_gate_toggle', 'false');
                        }
                        if(hasPassedTryLink) {
                            if(isCookieValueMatch) {
                                addednewscents.innerHTML = `<button type="button" class="kit-close active" data-selected-title="Select an Oil">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.59715 10.4031L10.4031 3.59716M3.59722 3.6531L10.3472 10.4031" stroke="black" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
                                <div class="image"><img src="${event.target.closest('button').dataset.variantImage}" alt="${event.target.closest('button').dataset.variantTitle}" width="125" height="125"></div>
                                <div class="selected-details active"><span class="title">${event.target.closest('button').dataset.variantTitle}</span><span class="pricing">
                                <span class="step-two-trynow-badge trynow-display-rule"><span class="trynow-badge">$0 NOW</span> <span class="trynow-badge-price">${event.target.closest('button').dataset.regularPrice}</span></span>
                                <span class="regular non-trynow-badge">${event.target.closest('button').dataset.compareAtPrice}</span>
                                <span class="compare-at-price non-trynow-badge">${event.target.closest('button').dataset.regularPrice}</span></span>
                                </div>`;

                            } else {
                                    addednewscents.innerHTML = `<button type="button" class="kit-close active" data-selected-title="Select an Oil">
                                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.59715 10.4031L10.4031 3.59716M3.59722 3.6531L10.3472 10.4031" stroke="black" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
                                <div class="image"><img src="${event.target.closest('button').dataset.variantImage}" alt="${event.target.closest('button').dataset.variantTitle}" width="125" height="125"></div>
                                <div class="selected-details active"><span class="title">${event.target.closest('button').dataset.variantTitle}</span><span class="pricing">
                                <span class="step-two-trynow-badge "><span class="trynow-badge">$0 NOW</span> <span class="trynow-badge-price">${event.target.closest('button').dataset.regularPrice}</span></span>
                                <span class="regular trynow-display-rule non-trynow-badge">${event.target.closest('button').dataset.compareAtPrice}</span>
                                <span class="compare-at-price trynow-display-rule non-trynow-badge">${event.target.closest('button').dataset.regularPrice}</span></span>
                                </div>`;
                            }
                        } else {
                            addednewscents.innerHTML = `<button type="button" class="kit-close active" data-selected-title="Select an Oil">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.59715 10.4031L10.4031 3.59716M3.59722 3.6531L10.3472 10.4031" stroke="black" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
                            <div class="image"><img src="${event.target.closest('button').dataset.variantImage}" alt="${event.target.closest('button').dataset.variantTitle}" width="125" height="125"></div>
                            <div class="selected-details active"><span class="title">${event.target.closest('button').dataset.variantTitle}</span><span class="pricing">
                            <span class="regular">${event.target.closest('button').dataset.compareAtPrice}</span>
                            <span class="compare-at-price">${event.target.closest('button').dataset.regularPrice}</span></span></div>`;
                        }
                        
                        _.selector.steptwovariantselected.classList.remove("active");
                        _.selector.steptwovariantselected.after(addednewscents);
                        // _.selector.secondvariantselecteditems.append(addednewscents);
                        _.state.step_two.push(event.target.closest('.item'));
                        _.recalculate();
                        if (window.innerWidth < 1025) {
                            document.querySelector('.steps-wizard').classList.add('active');
                            let scrollingSection = document.querySelector('.main-the-starter-kit');
                            scrollingSection.scrollTo({
                                top: scrollingSection.scrollHeight,
                                behavior: 'smooth'
                            });
                        } else {
                            window.scrollTo({top: top, behavior: 'smooth'});
                        }
                        document.querySelector('.step-two-variant-selected .kit-close.active').addEventListener('click', event => {
                            _.final.second_variants = [];
                            _.state.step_two = [];
                            _.final.withsubscription_el.textContent = '';
                            _.final.onetimepurchase_el.textContent = '';
                            event.target.closest(".step-two-variant-selected").remove();
                            document.querySelector('.step-two-variant-selected.initial').classList.add('active');
                            _.state.variantRunningCount = _.state.variantRunningCount - 1;
                            _.recalculate();      
                        })
                    }
                })
            })
        }
        if(_.selector.kitclose.length > 0) {
            _.selector.kitclose.forEach(close => {
                close.addEventListener('click', event => {
                    if(event.target.closest('.step-one-variant-selected')) {
                        event.target.closest('.step-one-variant-selected').querySelector('.image').innerHTML = "";
                        event.target.closest('button').classList.remove('active');
                        var spantext = document.createElement('span');
                        spantext.classList.add('label');
                        spantext.textContent =  event.target.closest('button').dataset.selectedTitle;
                        event.target.closest('.step-one-variant-selected').querySelector('.image').appendChild(spantext);
                        event.target.closest('.step-one-variant-selected').querySelector('.selected-details').classList.remove('active');
                        _.selector.steponecontainer.scrollIntoView({behavior: 'smooth', block: 'start'});     
                        _.state.step_one = [];
                        /*
                        _.final.second_variants = [];
                        _.state.variantRunningCount = 0;
                        _.selector.highlightcountscontainer.classList.remove("active");
                        const steptwovariantselected = document.querySelectorAll(".step-two-variant-selected");
                        if(steptwovariantselected.length > 0) {
                            Array.from(steptwovariantselected).map(el => {
                                if(el.classList.contains("active") && !el.classList.contains("initial")) {
                                    el.remove();
                                }
                                if(el.classList.contains("initial")) {
                                    el.classList.add("active");
                                }
                            })
                        }
                        */
                        _.recalculate();                
                    } 
                })
            })
        }
        if(_.selector.sellingplansubscriptionselection.length > 0) {
            _.selector.sellingplansubscriptionselection.forEach(el => {
                el.addEventListener("change", event => {
                    _.selector.sellingplansubscriptionselection.forEach(selection => {
                        selection.closest("label").classList.remove("active");
                    });
                    event.target.closest("label").classList.add("active");
                    if(event.target.value !== "one-time-purchase") {
                        _.final.subscription_plan = _.selector.sellingplanoptionsselect.options[_.selector.sellingplanoptionsselect.selectedIndex].dataset.sellingPlanId;
                        _.final.total_regular_price_el.style.textDecoration = "line-through";
                        _.final.total_regular_price_el.style.opacity = "0.4";
                        _.final.total_discounted_price_el.style.display = "inline";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.textDecoration = "line-through";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.display = "block";
                        document.querySelector('.step-two-variant-selected.active .regular').style.display = "block";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.opacity = "0.4";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.fontWeight = "400";
                    } else {
                        _.final.subscription_plan = "one-time-purchase";
                        _.final.total_discounted_price_el.style.display = "none";
                        _.final.total_regular_price_el.style.textDecoration = "none";
                        _.final.total_regular_price_el.style.opacity = "1";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.textDecoration = "none";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.opacity = "1";
                        document.querySelector('.step-two-variant-selected.active .compare-at-price').style.fontWeight = "600";
                        document.querySelector('.step-two-variant-selected.active .regular').style.display = "none";
                    }
                })
            })
        }
        if(_.selector.sellingplanoptionsselect) {
            _.selector.sellingplanoptionsselect.addEventListener("change", event => {
                document.querySelector('.selling-plan-subscription').click();
                _.final.subscription_plan = event.target.value;
                _.selector.steptwovariantselected.querySelector('.selected-details .selling-plan').textContent = event.target.options[event.target.selectedIndex].text;
            })
        }
        if(_.selector.mobilecollapsablearrow) {
            _.selector.mobilecollapsablearrow.addEventListener("click", event => {
                event.target.closest(".steps-wizard").classList.toggle("active");
            })
        }
        if(_.selector.secondvariantselecteditems) {
            _.selector.secondvariantselecteditems.addEventListener("click", event => {
                _.final.second_variants = event.target.closest(".step-two-variant-selected") ? _.final.second_variants.filter(variant => variant !== event.target.closest(".step-two-variant-selected").dataset.variantId) : [];
                _.state.step_two = event.target.closest(".step-two-variant-selected") ? _.state.step_two.filter(item => item.dataset.variantId !== event.target.closest(".step-two-variant-selected").dataset.variantId) : [];

                if(event.target.closest(".step-two-variant-selected") && !event.target.closest(".step-two-variant-selected").classList.contains("initial")) {
                    _.final.withsubscription_el.textContent = '';
                    _.final.onetimepurchase_el.textContent = '';
                    event.target.closest(".step-two-variant-selected").remove();
                    _.state.variantRunningCount = _.state.variantRunningCount - 1;
                } else {
                    return
                }
                if(_.final.second_variants.length == 0) {
                    _.selector.steptwovariantselected.classList.add("active");
                    _.state.variantRunningCount = 0;
                    _.selector.steptwocontainer.scrollIntoView({behavior: 'smooth', block: 'start'});  
                }
                _.recalculate();
            })
        }
        if(_.selector.starterkitaddtocart) {
            _.selector.starterkitaddtocart.addEventListener("click", () => {
                _.addtocart();
            })
        }
    }
    MainTheStarterKitTryNow.prototype.recalculate = function() {
        var _ = this;
        if(_.state.step_one.length > 0) {
            _.selector.stepsbuilderstepone.classList.add("disabled");           
            _.selector.highlightcountscontainer.classList.add("active");
            _.selector.highlightscentrunningscount.textContent = `${_.state.variantRunningCount}`;
            _.selector.highlightscentsmaxcount.textContent = `${_.state.variantSizeLimit}`;           
        } else {
            _.selector.stepsbuilderstepone.classList.remove("disabled");
            _.selector.highlightcountscontainer.classList.remove("active");
            _.selector.highlightscentrunningscount.textContent = ``;
            _.selector.highlightscentsmaxcount.textContent = ``;
        }
        if(_.state.step_one.length > 0 && _.final.second_variants.length > 0) {
            const final_first_discounted_price = (parseInt(_.final.first_product_discount_price) + parseInt(_.final.second_product_discount_price)) / 100;
            const final_total_discounted_price = final_first_discounted_price;
            const final_first_regular_price = (parseInt(_.final.first_product_price) + parseInt(_.final.second_product_price)) / 100;
            const final_total_regular_price = final_first_regular_price;
            _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            // to remove the decimals if the price doesn't have any
            if (_.final.total_discounted_price_el.textContent.slice(-2) == "00") {
                _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            if(final_total_discounted_price != final_first_regular_price) {
                _.final.total_regular_price_el.textContent = `${_.final.current_currency}${final_total_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.closest(".item").classList.remove("selected", "disabled");
                wizard.closest(".item button").classList.remove("disabled");
            })
        }
        if(_.state.step_two.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.closest(".item").classList.add("disabled");
            })
            _.state.step_two.forEach(step => {
                step.querySelector(".add-to-wizard").setAttribute('disabled', 'disabled');
                step.classList.add("selected");
                step.classList.remove("disabled");
            })
        } else {
            _.selector.addtowizard.forEach(wizard => {
                wizard.removeAttribute('disabled');
            })
        }
        if(window.diffUserVariants.length > 0 && _.state.step_one.length > 0) {
            const currentSelectedColor = _.state.step_one[0].variantTitle.split(" / ");
            let diffUserVariants = window.diffUserVariants.filter(variant => variant.variantTitle.includes(currentSelectedColor[0]));
            diffUserVariants = diffUserVariants.sort((a,b) => a.value - b.value);
            let notYetFoundHighestNumber = true;
            diffUserVariants.map(variant => {
                const splitVariantTitle = variant.variantTitle.split(" / ");
                if(notYetFoundHighestNumber && parseInt(_.state.variantRunningCount) <= parseInt(splitVariantTitle[1])) {
                    _.state.variantSizeLimit = 1;
                    notYetFoundHighestNumber = false;                        
                    _.final.first_variant_id = variant.variantId;
                    _.final.first_variant_available = variant.variantAvailable === "true" ? true : false;
                    const variantSplitValue = variant.variantTitle.split(" / ");
                    _.selector.highlightscentsmaxcount.textContent = `${variantSplitValue[1]}`;
                    _.selector.steponevariantselected.querySelector('.selected-details .title').textContent = variant.productTitle.split(' / ')[0];
                    _.selector.steponevariantselected.querySelector('.selected-details .pricing .regular').textContent = variant.variantPrice;
                    _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
                }
            })
        }
        if(_.state.variantRunningCount == 1 && _.state.step_one.length > 0) {
            _.selector.starterkitaddtocart.disabled = false;
        } else {
            _.selector.starterkitaddtocart.disabled = true;
        }
        _.removeTryNowSellingPlan();
        if(window.trynow) _.tryNowAtcValidation();
    }
    MainTheStarterKitTryNow.prototype.addtocart = async function() {
        var _ = this;
        var formData;
        if(_.selector.complimentaryselected && _.selector.complimentaryselected.dataset.variantAvailable == "true") {
            if(_.final.subscription_plan !== "one-time-purchase") {
                formData = {
                    'items': [
                        {
                            'id': parseInt(_.final.first_variant_id),
                            'quantity': 1
                        },
                        {
                            'id': parseInt(_.selector.complimentaryselected.dataset.variantId),
                            'quantity': 1
                        },
                        {
                            'id': parseInt(_.final.second_variants[0]),
                            'quantity': 1,
                            'selling_plan': parseInt(_.final.subscription_plan)
                        }
                    ],
                    'attributes': {
                        'Starter Kit': 'True'
                    }
                };
            } else {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.selector.complimentaryselected.dataset.variantId),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                            }
                    ],
                    'attributes': {
                        'Starter Kit': 'True'
                    }
                    };

            }
        } else {
            if (_.final.subscription_plan !== "one-time-purchase") {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                                'selling_plan': parseInt(_.final.subscription_plan)
                            }
                        ],
                        'attributes': {
                            'Starter Kit': 'True'
                        }
                    };
            } else {
                formData = {
                    'items': [
                            {
                                'id': parseInt(_.final.first_variant_id),
                                'quantity': 1
                            },
                            {
                                'id': parseInt(_.final.second_variants[0]),
                                'quantity': 1,
                            }
                        ],
                        'attributes': {
                            'Starter Kit': 'True'
                        }
                    };
            }
        }
        _.selector.starterkitaddtocart.setAttribute('disabled', 'disabled');
        _.selector.starterkitaddtocart.querySelector('.text-line').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.pricing').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.remove('hide');
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
            return response.json();
        })
        .then(data => {
        })
        .catch((error) => {
            console.error('Error:', error);
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
        });           
    }
    MainTheStarterKitTryNow.prototype.removeTryNowSellingPlan = function() {
        var _ = this;
        if(_.state.step_one && _.state.step_one.length > 0 || _.state.step_two && _.state.step_two.length > 0) {
            //code to remove trynow selling plan on safari
            const trynowOption = document.querySelectorAll("option[data-selling-plan-id='4571005184']");
            if (trynowOption && trynowOption.length > 0) {
                trynowOption.forEach((item) => {
                    item.remove();
                })
            }
            //code to remove trynow selling plan on safari
        }
    }
    MainTheStarterKitTryNow.prototype.tryNowAtcValidation = function() {
      if(window.trynow) {
          var _ = this;
          if(_.state.step_one && _.state.step_one.length > 0 && _.state.step_two && _.state.step_two.length > 0) {
              _.selector.tryNowCta.removeAttribute('disabled');
              _.tryNowLimitValidation();
          } else {
              _.selector.tryNowCta.setAttribute('disabled', 'disabled');
          }
      }
    }
    MainTheStarterKitTryNow.prototype.onTryNowAddToCart = async function() {
        var _ = this;
        var formData;
        let sellingPlan = await window.trynow.getSellingPlanId();
        const sellingPlanId = sellingPlan.split("/").pop();

        if(_.selector.complimentaryselected && _.selector.complimentaryselected.dataset.variantAvailable == "true") {
          formData = {
            'items': [
              {
                  'id': parseInt(_.final.first_variant_id),
                  'selling_plan': parseInt(sellingPlanId),
                  'properties': {
                    '_trynow_related_item':  parseInt(_.final.second_variants[0])
                    },
                  'quantity': 1
              },
              {
                  'id': parseInt(_.selector.complimentaryselected.dataset.variantId),
                  'selling_plan': parseInt(sellingPlanId),
                  'quantity': 1
              },
              {
                  'id': parseInt(_.final.second_variants[0]),
                  'selling_plan': parseInt(sellingPlanId),
                  'properties': {
                        '_trynow_related_item':  parseInt(_.final.first_variant_id),
                        '_trynow_related_kit': 'starter_kit'
                    },
                  'quantity': 1,
              }
            ],
            'attributes': {
                'Starter Kit': 'True'
            }
          };
        } else {
          formData = {
            'items': [
                  {
                      'id': parseInt(_.final.first_variant_id),
                      'selling_plan': parseInt(sellingPlanId),
                      'properties': {
                        '_trynow_related_item':  parseInt(_.final.second_variants[0])
                      },
                      'quantity': 1,
                  },
                  {
                      'id': parseInt(_.final.second_variants[0]),
                      'selling_plan': parseInt(sellingPlanId),
                      'properties': {
                        '_trynow_related_item':  parseInt(_.final.first_variant_id),
                        '_trynow_related_kit': 'starter_kit'
                    },
                      'quantity': 1,
                  }
                ],
                'attributes': {
                    'Starter Kit': 'True'
                }
            };
        }
        _.selector.tryNowCta.setAttribute('disabled', 'disabled');
        _.selector.tryNowCta.querySelector('.text-line').classList.add('hide');
        _.selector.tryNowCta.querySelector('[data-loader]').classList.remove('hide');
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            _.selector.tryNowCta.removeAttribute('disabled');
            _.selector.tryNowCta.querySelector('[data-loader]').classList.add('hide');
            _.selector.tryNowCta.querySelector('.text-line').classList.remove('hide');
            return response.json();
        })
        .then(async data => {
          await window.trynow.addToCartClicked();
        })
        .catch((error) => {
            console.error('Error:', error);
            _.selector.tryNowCta.removeAttribute('disabled');
            _.selector.tryNowCta.querySelector('[data-loader]').classList.add('hide');
            _.selector.tryNowCta.querySelector('.text-line').classList.remove('hide');
        });           
    }
    MainTheStarterKitTryNow.prototype.getCookieValue = function(cookieName) {
      let name = cookieName + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let cookieArray = decodedCookie.split(';');
      
      for(let i = 0; i < cookieArray.length; i++) {
          let cookie = cookieArray[i].trim();
          if (cookie.indexOf(name) === 0) {
              return cookie.substring(name.length, cookie.length);
          }
      }
      return null;
    }
    MainTheStarterKitTryNow.prototype.checkCookieValue = function(cookieName, valueToCheck) {
      var _ = this;
      let cookieValue = _.getCookieValue(cookieName);
      return cookieValue === valueToCheck;
    }

    MainTheStarterKitTryNow.prototype.tryNowOnToggleClick = async function() {
        var _ = this;
        let isCookieValueMatch = await _.checkCookieValue('_tn_gate_toggle', 'false');
        if(isCookieValueMatch) {
            document.cookie = `_tn_gate_toggle=; expires=${new Date(0).toUTCString()}; path=/;`;
            await _.tryNowValidation();
        } else {
            const maxAge = 30 * 24 * 60 * 60;
            const expires = new Date(Date.now() + maxAge * 1000).toUTCString();
            document.cookie = `_tn_gate_toggle=false; path=/; expires=${expires}`;
            await _.tryNowValidation();
        }
    }
    
    MainTheStarterKitTryNow.prototype.tryNowValidation = async function() {
        var _ = this;
        if(!window.trynow) return;

        let hasPassedTryLink = await window.trynow.hasPassedTryLink();
        let isCookieValueMatch = await _.checkCookieValue('_tn_gate_toggle', 'false');

        let sellingPlanContainer = document.querySelectorAll('.selling-plan-option-outer');
        let tryNowCta = document.querySelector('#trynow-custom-cta');
        let tryNowInfoBoxContainer = document.querySelector('.trynowDescriptionContainer');
        let tryNowInfoBoxContainerLimit = document.querySelector('.tnLimitDescription');
        let starterKitAddToCart = document.getElementById("starter-kit-add-to-cart");
        let toggleText = document.querySelector('#trynow-toggle-text');
        let trynowBannerContainer = document.querySelector('.trynow-banner-pdp');
        let trynowHiwBannerContainer = document.querySelector('.trynow-hiw-banner');
        let allNonTryNowBadges = document.querySelectorAll('.non-trynow-badge');
        let stepTwoTryNowBadge = document.querySelectorAll('.step-two-trynow-badge');
        let stepOneTryNowBadge = document.querySelector('.step-one-trynow-badge');

        let imageTryNowBadge = document.querySelectorAll('.trynow-image-badge');
        
        if(!hasPassedTryLink) {
            _.selector.tryNowCtaContainer.classList.add('trynow-display-rule');
            return;
        } 

        if(isCookieValueMatch) {
            toggleText.textContent = "I'd like to try before I buy";
            tryNowCta.classList.add('trynow-display-rule');
            tryNowInfoBoxContainer.classList.add('trynow-display-rule');
            tryNowInfoBoxContainerLimit.classList.add('trynow-display-rule');
            if(trynowBannerContainer) trynowBannerContainer.classList.add('trynow-banner-hide');
            if(trynowHiwBannerContainer) trynowHiwBannerContainer.classList.add('trynow-hiw-banner-hide');
            starterKitAddToCart.classList.remove('trynow-display-rule');
            if(stepOneTryNowBadge) stepOneTryNowBadge.classList.add('trynow-display-rule')
            if(sellingPlanContainer) {
                sellingPlanContainer.forEach((item) => {
                item.classList.remove('trynow-display-rule');
                })
            }
            if(allNonTryNowBadges) {
                allNonTryNowBadges.forEach((item) => {
                    item.classList.remove('trynow-display-rule');
                })
            }
            if(stepTwoTryNowBadge) {
                stepTwoTryNowBadge.forEach((item) => {
                    item.classList.add('trynow-display-rule');
                })
            }
            // delete
            if(imageTryNowBadge) {
                imageTryNowBadge.forEach((item) => {
                    item.classList.add('trynow-display-rule');
                })
            }
        } else {
            toggleText.textContent = "I'll buy before trying";
            tryNowCta.classList.remove('trynow-display-rule');
            tryNowInfoBoxContainer.classList.remove('trynow-display-rule');
            tryNowInfoBoxContainerLimit.classList.remove('trynow-display-rule');
            starterKitAddToCart.classList.add('trynow-display-rule');
            if(trynowBannerContainer) trynowBannerContainer.classList.remove('trynow-banner-hide');
            if(trynowHiwBannerContainer) trynowHiwBannerContainer.classList.remove('trynow-hiw-banner-hide');
            if(stepOneTryNowBadge) stepOneTryNowBadge.classList.remove('trynow-display-rule')
            if(sellingPlanContainer) {
                sellingPlanContainer.forEach((item) => {
                item.classList.add('trynow-display-rule');
                })
            }
            if(allNonTryNowBadges) {
                allNonTryNowBadges.forEach((item) => {
                    item.classList.add('trynow-display-rule');
                })
            }
            if(stepTwoTryNowBadge) {
                stepTwoTryNowBadge.forEach((item) => {
                    item.classList.remove('trynow-display-rule');
                })
            }
            // delete
            if(imageTryNowBadge) {
                imageTryNowBadge.forEach((item) => {
                    item.classList.remove('trynow-display-rule');
                })
            }
        } 
    }
    MainTheStarterKitTryNow.prototype.tryNowLoad = async function() {
        var _ = this;
        if(!window.trynow) return;

        _.selector.tryNowCta.addEventListener('click', () => {
            _.onTryNowAddToCart()
        })      

        const trynowTrialPeriodRender = await window.trynow.getTrialPeriodDays();
        let trynowTrialPeriodLabel = trynowTrialPeriodRender > 1 ? `${trynowTrialPeriodRender} days` : `${trynowTrialPeriodRender} day`;
        let svgString = `<svg width="46" style="position:relative;top:4px;left:0px" viewBox="0 0 787 229"><path fill="black" d="M547.051 33.393c-28.899 0-52.32 23.408-52.32 52.29v48.913c0 28.882 23.421 52.289 52.32 52.289 28.898 0 52.319-23.407 52.319-52.289V85.683c0-28.882-23.421-52.29-52.319-52.29Zm14.124 103.132c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V83.711c0-7.802 6.317-14.115 14.124-14.115s14.124 6.313 14.124 14.115v52.814ZM104.723 71.9V35.574H38.196V0H0v134.573c0 28.882 23.421 52.289 52.32 52.289 28.898 0 52.32-23.407 52.32-52.289V99.356H66.444v37.146c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V71.88h66.527v.02Zm88.008-38.509c-15.152 0-24.806 7.908-30.829 18.08V35.594h-37.818l-.105 148.269h38.195V83.73c0-7.802 6.317-14.116 14.124-14.116s14.124 6.314 14.124 14.116v37.146h38.196V85.66c0-28.882-12.025-52.29-35.887-52.29v.021Zm88.688 153.408c15.153 0 24.806-7.907 30.83-18.08v60.26h37.818l.105-192.672h-38.196v100.132c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V36.328h-38.196v98.182c0 28.882 12.025 52.289 35.887 52.289ZM442.247 33.393c-15.152 0-24.806 7.908-30.829 18.08V35.596H373.6l-.105 148.269h38.196V83.732c0-7.802 6.317-14.115 14.124-14.115s14.124 6.313 14.124 14.115v100.133h38.196V85.683c0-28.882-12.026-52.29-35.888-52.29Zm306.565 2.935V136.46c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116v-1.72s.042-.146.042-.23V36.328h-38.238v98.182s.021.147.042.23v1.72c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V36.328h-38.195v98.182c0 28.882 16.453 52.289 44.596 52.289 22.12 0 36.013-13.759 40.924-28.609 4.932 14.85 18.804 28.609 40.924 28.609 28.143 0 44.597-23.407 44.597-52.289V36.328h-38.196Z"></path></svg>`;
        let trynowInfoBox = document.createElement('div');
        let onlyPayLabel = `Only pay if you love it.`;
        trynowInfoBox.id = 'trynow-info-box';
        trynowInfoBox.innerHTML = `
        <div id="custom-trynow-container">
            <div class="tnDescription trynowDescriptionContainer trynow-display-rule">
                <ul class="trynow-features">
                    <li class="trynow-feature">
                        <img class="trynow-feature-icon" src="https://cdn.shopify.com/s/files/1/0487/2798/2229/files/Vector.png?v=1737989298" alt="">
                        <span>Try for ${trynowTrialPeriodLabel} in the comfort of your home.</span>
                    </li>
                    <li class="trynow-feature">
                        <img class="trynow-feature-icon" src="https://cdn.shopify.com/s/files/1/0487/2798/2229/files/Vector.png?v=1737989298" alt="">
                        <span>${onlyPayLabel}</span>
                    </li>
                    <li class="trynow-feature">
                        <img class="trynow-feature-icon" src="https://cdn.shopify.com/s/files/1/0487/2798/2229/files/Vector.png?v=1737989298" alt="">
                        <span>Free shipping &amp; returns.</span>
                    </li>
                </ul>
                <hr class="trynow-divider">
                <div class="tryNowShopper">Powered by <a target="_blank" href="https://www.trynow.com/shopper">${svgString}</a></div>
                <div class="trynow-how-it-works"><span class="trynowHowItWorksLink">How it works <span class="trynow-hiw-arrow">&rsaquo;</span></span></div>
            </div>

            <div class="tnLimitDescription trynow-disabled-rule trynow-display-rule">
                <span>Try Before You Buy has reached the limit</span>
            </div>
        
            <p class="tryNowSwitch"><span class="trynow-toggle-settings">No thanks, <span id="trynow-toggle-text">I'll buy before trying</span></span></p>
        </div>
        `;
        _.selector.tryNowCtaContainer.insertAdjacentElement('beforeend',trynowInfoBox);

            let toggleContainer = document.querySelector('.tryNowSwitch');
            if(toggleContainer) {
                toggleContainer.addEventListener('click', (event) => {
                    event.preventDefault();
                    _.tryNowOnToggleClick()
                       
                    if (window.innerWidth < 1025) {
                        setTimeout(() => {
                            let scrollingSection = document.querySelector('.steps-wizard');
                            scrollingSection.scrollIntoView({behavior: 'smooth', block: 'start'});
                        }, 100)
                    }
                })

            }
        _.tryNowValidation();
        _.tryNowLimitValidation();
    }
    MainTheStarterKitTryNow.prototype.tryNowLimitValidation = async function() {
        var _ = this;
        if (!window.trynow) return;
  
        const cartResponse = await fetch('/cart.js');
        const cart = await cartResponse.json();

        const tryNowItems = cart.items.filter(item =>
            item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan &&
            item.selling_plan_allocation.selling_plan.name.toLowerCase().includes('try')
        );

        const tryNowScentifyItem = cart.items.filter(item => 
            item.selling_plan_allocation && 
            item.selling_plan_allocation.selling_plan.name.toLowerCase().includes('try') &&
            item.handle == 'scentify-plug-in-diffuser-v2'
        );
        
        let tryNowInfoBox = document.querySelector('#custom-trynow-container');
        if (_.selector.tryNowCta && tryNowInfoBox) {
            if(tryNowScentifyItem && tryNowScentifyItem.length > 0) {
                let tryNowDescriptionContainer = tryNowInfoBox.querySelector('.trynowDescriptionContainer');
                let tryNowLimitDescription = tryNowInfoBox.querySelector('.tnLimitDescription');
                if(tryNowDescriptionContainer) tryNowDescriptionContainer.classList.add('trynow-disabled-rule')
                if(tryNowLimitDescription) tryNowLimitDescription.classList.remove('trynow-disabled-rule')
                _.selector.tryNowCta.classList.add('trynow-limit-rule');
            } else {
                let tryNowDescriptionContainer = tryNowInfoBox.querySelector('.trynowDescriptionContainer');
                let tryNowLimitDescription = tryNowInfoBox.querySelector('.tnLimitDescription');
                if(tryNowDescriptionContainer) tryNowDescriptionContainer.classList.remove('trynow-disabled-rule')
                if(tryNowLimitDescription) tryNowLimitDescription.classList.add('trynow-disabled-rule')          
                _.selector.tryNowCta.classList.remove('trynow-limit-rule');
            }
        }

    }
    MainTheStarterKitTryNow.prototype.onBrowserLoad = function() {
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isMetaBrowser = ua.includes("FBAN") || ua.includes("FBAV") || ua.includes("Instagram");
        if (isMetaBrowser) {
            let url = new URL(window.location.href);
            url.searchParams.set("_tng_meta", "hERrF3Y9BCjTfz5jZ62E8");
            window.history.pushState({}, "", url);
        }
    }
    MainTheStarterKitTryNow.prototype.onMetaBrowser = async function() {
        var _ = this;
        let url = new URL(window.location.href);
        let fbClid = url.searchParams.get("fbclid");
        let tng = url.searchParams.get("_tng_meta");
        let isCookieValueMatch = await _.checkCookieValue('_tn_gate', 'gated_link');
        if(fbClid && tng && !isCookieValueMatch) {
            url.searchParams.set("tng", "hERrF3Y9BCjTfz5jZ62E8");
            url.searchParams.delete("_tng_meta");
            window.history.pushState({}, "", url);
        }
    }
    
    MainTheStarterKitTryNow = new MainTheStarterKitTryNow;
}
MainTheStarterKitTryNow();